import BigNumber from "bignumber.js";
import { parseUnits } from "viem";

export const BIG_TEN = new BigNumber(10);

/**
 * Take a formatted amount, e.g. 15 ETH and convert it to full decimal value, e.g. 15000000000000000
 */
export const getDecimalAmount = (amount: string | undefined, decimals = 18): string => {
  if (!amount) return '';
  return parseUnits(String(amount), decimals)
    .toString();
};

export const getBalanceAmount = (amount: BigNumber, decimals = 18) => {
  return new BigNumber(amount).dividedBy(BIG_TEN.pow(decimals));
};

/**
 * This function is not really necessary but is used throughout the site.
 */
export const getBalanceNumber = (balance: any, decimals: any) => {
  return getBalanceAmount(balance, decimals).toNumber();
};

export const getFullDisplayBalance = (
  balance: BigNumber,
  decimals = 18,
  decimalsToAppear?: number
) => {
  return getBalanceAmount(balance, decimals).toFixed(decimalsToAppear || 2);
};

export const getFullDisplayBalance2 = (
  balance: BigNumber,
  decimals = 18,
  decimalsToAppear?: number
) => {
  return `${getBalanceAmount(balance, decimals).div(1000).toFixed(0)}K`;
};

export const formatNumber = (
  number: number,
  minPrecision = 2,
  maxPrecision = 2
) => {
  const options = {
    minimumFractionDigits: minPrecision,
    maximumFractionDigits: maxPrecision,
  };
  return number.toLocaleString(undefined, options);
};

export const formatDecimalNumber = (input: string): string => {
  const number = parseFloat(input);
  const formattedNumber = number.toFixed(2);
  const integerPart = Math.floor(number);

  if (number === integerPart) {
    return integerPart.toString();
  }

  return formattedNumber;
}

export const shorter = (str: any) =>
  str?.length > 8 ? str.slice(0, 4) + "..." + str.slice(-4) : str;
